import { useFormikContext } from "formik";
import Box from "@mui/material/Box";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import CreatableSoftSelect from "components/CreatableSoftSelect";
import FormField from "layouts/Flow Designer/components/FormField";
import { truncateInputValue } from "helpers/fieldListeners";
import { useFlowForm } from "../FlowForm/context";

const Properties = () => {
   const { values, errors, touched, setFieldValue } = useFormikContext();
   const {
      allowEditWorkflow,
      currentSavedFlow,
      createIntegrationDefaultValue,
      createIntegrationsOptions,
      fields: { flowName, description, flowId, integration, returnValue },
      validateFlowName
   } = useFlowForm();

   return (
      <Box sx={{ padding: "0 3px 5px" }}>
         <FormField type={flowId.type} label={flowId.label} name={flowId.name} disabled readOnly value={currentSavedFlow?.id || ""} />
         <FormField
            id="flowName"
            type={flowName.type}
            label={flowName.label}
            name={flowName.name}
            onInput={truncateInputValue(50)}
            validate={validateFlowName}
            error={errors.flowName && touched.flowName}
            placeholder={flowName.placeholder || ""}
            required
            disabled={!allowEditWorkflow}
         />
         <FormField
            type={description.type}
            label={description.label}
            name={description.name}
            onInput={truncateInputValue(500)}
            error={errors[description.name] && touched[description.name]}
            placeholder={description.placeholder || ""}
            isMultiline
            disabled={!allowEditWorkflow}
         />
         <SoftBox mb={2}>
            <SoftTypography variant="h6" mb={1} sx={{ fontSize: "12px" }}>
               Integrations
            </SoftTypography>
            <CreatableSoftSelect
               className="responsive-multi-height"
               placeholder="Select Integrations"
               options={createIntegrationsOptions()}
               isMulti
               value={createIntegrationDefaultValue(values.integration)}
               sx={{ zIndex: 0 }}
               hideSelectedOptions={false}
               onChange={(selectedOptions) => setFieldValue(integration.name, selectedOptions.map((option) => option.value))}
               isDisabled={!allowEditWorkflow}
            />
         </SoftBox>
         <FormField
            type={returnValue.type}
            label={returnValue.label}
            name={returnValue.name}
            error={errors[returnValue.name] && touched[returnValue.name]}
            options={returnValue.options}
            defaultValue={returnValue.options.find((option) => option.value === values.returnValue)}
            isDisabled={!allowEditWorkflow}
         />
      </Box>
   );
};

export default Properties;

